<template>
	<div id="app">
		<router-view ref="routerView" ></router-view>
	</div>
</template>

<script>
	export default {
		name: "App",
		data() {
			return {
				
			};
		},
		methods: {},
	};
</script>

<style lang="less">
	@vm_base: 1/750 * 100vw;
	@import "./common/custom_sys.less";
	
	// @import './common/index.css'

	::-webkit-scrollbar {
		width: 0;
		height: 0;
	}

	// ::-webkit-scrollbar-thumb {
	//   background: #FB9427;
	// }

	* {
		padding: 0;
		margin: 0;
		font-family: PingFangSC-Medium, PingFang SC, sans-serif;
		box-sizing: border-box;
	}

	div,
	span,
	label {
		box-sizing: border-box;
		word-break: break-all;
		line-height: 1;
		font-weight: normal;
	}

	#app {
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		box-sizing: border-box;
		min-height: 100vh;
		height: auto;
		background-color: #fff;
	}
</style>


// WEBPACK FOOTER //
// src/App.vue